let currentTikTokPixel = null;

export function initTikTokPixel(pixel) {
  if (!pixel) return;

  // 已经初始化同一个 Pixel
  if (currentTikTokPixel === pixel && window.ttq?._i?.[pixel]) {
    return;
  }

  // 初始化 TikTok Pixel SDK
  if (!window.ttq) {
    window.TiktokAnalyticsObject = "ttq";

    const ttq = (window.ttq = window.ttq || []);

    ttq.methods = [
      "page",
      "track",
      "identify",
      "instances",
      "debug",
      "on",
      "off",
      "once",
      "ready",
      "alias",
      "group",
      "enableCookie",
      "disableCookie",
    ];

    ttq.setAndDefer = function (target, method) {
      target[method] = function () {
        target.push([method].concat(Array.prototype.slice.call(arguments, 0)));
      };
    };

    for (let i = 0; i < ttq.methods.length; i++) {
      ttq.setAndDefer(ttq, ttq.methods[i]);
    }

    ttq.instance = function (pixelId) {
      const instance = ttq._i[pixelId] || [];

      for (let i = 0; i < ttq.methods.length; i++) {
        ttq.setAndDefer(instance, ttq.methods[i]);
      }

      return instance;
    };

    ttq.load = function (pixelId, options) {
      const sdkUrl = "https://analytics.tiktok.com/i18n/pixel/events.js";

      ttq._i = ttq._i || {};
      ttq._i[pixelId] = [];

      ttq._i[pixelId]._u = sdkUrl;

      ttq._t = ttq._t || {};
      ttq._t[pixelId] = +new Date();

      ttq._o = ttq._o || {};
      ttq._o[pixelId] = options || {};

      const script = document.createElement("script");

      script.type = "text/javascript";
      script.async = true;
      script.src = `${sdkUrl}?sdkid=${pixelId}&lib=ttq`;

      const firstScript = document.getElementsByTagName("script")[0];

      firstScript.parentNode.insertBefore(script, firstScript);
    };
  }

  // 加载当前 Pixel
  window.ttq.load(pixel);

  // 发送 PageView
  window.ttq.page();
  console.log("pageview");

  // 记录当前 Pixel
  currentTikTokPixel = pixel;
}
